module.exports = __webpack_public_path__ + "static/img/13wr.a74556a8.webp";